

import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ILanguage } from '~/interfaces/language'
import departments from '~/services/departments'
import Carousel from '~/components/shared/carousel.vue'
import CarouselSlide from '~/components/shared/carousel-slide.vue'
import AppLink from '~/components/shared/app-link.vue'

type BlockSlideshowLayout = 'full' | 'with-departments';

interface SlideImage {
    ltr: string
    rtl: string
}

interface Slide {
    title: string
    text: string
    imageClassic: SlideImage
    imageFull: SlideImage
    imageMobile: SlideImage
}

@Component({
    components: { CarouselSlide, Carousel, AppLink },
})
export default class BlockSlideshow extends Vue {
    @Prop({ type: String, default: () => 'full' }) readonly layout!: BlockSlideshowLayout
    @Prop({ type: Array, default: () => []}) readonly banners!: any
    @Getter('locale/language') language!: ILanguage

    slides: Slide[] = []

    get direction () {
        return this.language.direction
    }

    async mounted () {
        departments.set(this.$el)
    }

    beforeDestroy () {
        departments.set(null)
    }

    getDesktopImage (slide: Slide): string {
        const url = (this.layout === 'with-departments' ? slide.imageClassic : slide.imageFull)[this.direction]

        return `url(${this.$url.img(url)})`
    }

    getMobileImage (slide: Slide): string {
        return `url(${this.$url.img(slide.imageMobile[this.direction])})`
    }

    image (banner) {
        if (banner) {
            const { id, bannerimg } = banner
            return (id && bannerimg) ? `url(${this.$url.image('headerbanners', id, bannerimg)})` : "https://via.placeholder.com/1110x450.png"
        }
    }

    redirectToPage (data) {
        if (data.btnurl != "") {
            window.open(data.btnurl, "_blank")
        }
    }
}

